// extracted by mini-css-extract-plugin
module.exports = {"numero":"ListeAvoirs_numero__46F9J"};